import {
    CLIENT_PLUGIN_SETCONFIGURATIONS,
    CLIENT_PLUGIN_RESET_CONFIGURATIONS,
    CLIENT_PLUGIN_SETNOTES,
    CLIENT_PLUGIN_RESET_NOTES,
    CLIENT_PLUGIN_RESET_CONFIGURATIONBYPLUGIN,
    CLIENT_PLUGIN_RESET_NOTEBYPLUGIN,
} from '../ActionTypes';

const initActions = (services) => {
    const axiosCall = services.axios.Axios();

    const fetchClientManifest = (instanceId) => async () => {
        try {
            var res = await axiosCall.get(`ClientManifest/${instanceId}`);
            return res.data;
        } catch (err) {
            console.error(err);
            return null;
        }
    };

    const fetchMissionControlStatus = (instanceId) => async () => {
        var res = await axiosCall.get(
            `Instances/MissionControl/status?instanceId=${instanceId}`
        );
        return res.data;
    };

    const setPluginConfiguration = (pluginConfiguration) => {
        return {
            type: CLIENT_PLUGIN_SETCONFIGURATIONS,
            payload: pluginConfiguration,
        };
    };

    const resetPluginConfigurations = (pluginConfigurations = []) => {
        return {
            type: CLIENT_PLUGIN_RESET_CONFIGURATIONS,
            payload: pluginConfigurations,
        };
    };

    const setPluginNote = (pluginNote) => {
        return {
            type: CLIENT_PLUGIN_SETNOTES,
            payload: pluginNote,
        };
    };

    const resetPluginNotes = (pluginNotes = []) => {
        return {
            type: CLIENT_PLUGIN_RESET_NOTES,
            payload: pluginNotes,
        };
    };

    const resetPluginConfigurationByPlugin = (pluginId) => {
        return {
            type: CLIENT_PLUGIN_RESET_CONFIGURATIONBYPLUGIN,
            payload: pluginId,
        };
    };

    const resetPluginNoteByPlugin = (pluginId) => {
        return {
            type: CLIENT_PLUGIN_RESET_NOTEBYPLUGIN,
            payload: pluginId,
        };
    };

    const removeClientPlugin =
        (instanceId, pluginId, pluginVersion) => async () => {
            try {
                await axiosCall.delete(
                    `ClientManifest/${instanceId}/client-plugin?pluginId=${pluginId}&pluginVersion=${pluginVersion}`
                );

                return {
                    isSuccess: true,
                    message: 'Remove Plugin succeeded!',
                };
            } catch (error) {
                return {
                    isSuccess: false,
                    message: 'Rmove Plugin failed!',
                };
            }
        };

    const addClientPlugin = (instanceId, clientPlugin) => async () => {
        try {
            var res = await axiosCall.post(
                `ClientManifest/${instanceId}/client-plugin`,
                clientPlugin
            );

            if (res.status === 200) {
                return {
                    isSuccess: true,
                    message: 'Add Plugin succeeded!',
                };
            } else {
                return {
                    isSuccess: false,
                    message: 'Add Plugin failed!',
                };
            }
        } catch (error) {
            // This is jank, header information (including auth info) gets passed down in error response. Removing that out
            var errorMsg = error.response.data;
            var errorMsgSplit = error.response.data.split('HEADERS');
            errorMsg = errorMsgSplit[0].trim();
            return {
                isSuccess: false,
                message: errorMsg,
            };
        }
    };

    const updateClientPlugin = (instanceId, updatedPlugin) => async () => {
        try {
            await axiosCall.put(
                `ClientManifest/${instanceId}/client-plugin`,
                updatedPlugin
            );
            return {
                isSuccess: true,
                message: 'Plugin update succeeded!',
            };
        } catch (error) {
            return {
                isSuccess: false,
                message: 'Plugin update failed!',
            };
        }
    };

    //Push manifest to the Practice
    const triggerPushManifestToPractice = (instanceId) => async () => {
        try {
            var res = await axiosCall.post(
                `ClientManifest/client-plugin/pushmanifest/${instanceId}`
            );

            if (res.status === 200) {
                return {
                    isSuccess: true,
                    message: 'Push manifest succeeded!',
                };
            } else {
                return {
                    isSuccess: false,
                    message: 'Push manifest failed!',
                };
            }
        } catch (error) {
            const errorMsg = error.message;
            console.error(errorMsg);
            return { isSuccess: false, message: 'Error pushing manifest' };
        }
    };

    //State Changes Commands
    const triggerInitiateStateCommand = (
        instanceId,
        pluginId,
        command = ''
    ) => {
        return async () => {
            try {
                await axiosCall.post(
                    `ClientManifest/client-plugin/${instanceId}/statecommand/${pluginId}?command=${command}`
                );
            } catch (error) {
                const errorMsg = error.message;
                console.error(errorMsg);
            }
        };
    };

    const updateMissionControlVersion = (instanceId, version) => {
        return async () => {
            try {
                await axiosCall.patch(
                    `ClientManifest/${instanceId}/mission-control-version/${version}`
                );
                return {
                    isSuccess: true,
                    message: 'Mission Control version updated',
                };
            } catch (error) {
                return {
                    isSuccess: false,
                    message: 'Error updating Mission Control version',
                };
            }
        };
    };

    return {
        fetchClientManifest,
        fetchMissionControlStatus,
        setPluginConfiguration,
        setPluginNote,
        removeClientPlugin,
        addClientPlugin,
        resetPluginConfigurations,
        resetPluginNotes,
        resetPluginConfigurationByPlugin,
        resetPluginNoteByPlugin,
        updateClientPlugin,
        triggerPushManifestToPractice,
        triggerInitiateStateCommand,
        updateMissionControlVersion,
    };
};

export default initActions;
